import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import store from 'Redux/store';

export default function DiscoverLink({ setMegaMenuTab, megaMenuTab }) {
  const [delayHandler, setDelayHandler] = useState(null);

  const clickButton = () => {
    setMegaMenuTab(megaMenuTab === '' ? 'discover' : '');
    setTimeout(() => {
      const navLink = document.getElementById('discover-gamedeals');
      if (navLink) navLink.focus();
    }, 200);

    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: 'SecondaryNavLinks', value: '/search', context: 'Discover' },
    });
  };

  const handleMouseEnter = () => {
    setDelayHandler(setTimeout(() => {
      setMegaMenuTab('discover');
    }, 200));
  };

  const handleMouseLeave = () => {
    clearTimeout(delayHandler);
    setMegaMenuTab('');
  };

  return (
    <div className="store-link-button">
      <Link
        id="MegaMenu_discover__link"
        aria-expanded={megaMenuTab === 'discover'}
        aria-controls="MegaMenu_discover"
        aria-haspopup="true"
        aria-label="discover, dropdown"
        to="/search"
        className="secondary-nav-link"
        onClick={() => { clickButton(); }}
        onMouseEnter={() => { handleMouseEnter(); }}
        onMouseLeave={() => { handleMouseLeave(); }}
      >
        <FormattedMessage id="discover-link.name" defaultMessage="Discover" />
        <div className="link-arrow" />
      </Link>
    </div>
  );
}

DiscoverLink.propTypes = {
  setMegaMenuTab: PropTypes.func,
  megaMenuTab: PropTypes.string,
};

DiscoverLink.defaultProps = {
  setMegaMenuTab: () => {},
  megaMenuTab: '',
};
